
import Vue from 'vue'
import Vuex from 'vuex'
import * as u from '@/utils/util'
//webSocket
import webSocket from './modules/webSocket';
//打开的标签页
import menuTab from './modules/menuTab';
// 用户模块
import user from './modules/user';
// 挂载vuex
Vue.use(Vuex)


const store =new Vuex.Store({
  // 全局属性变量
  state: {
    userInfo:u.getSession("userInfo"),
  },
  // 全局同步方法, 调用方法,this.$store.commit("xxx")
  mutations: {
    setUserInfo(state,data){
      state.userInfo = data
    },
    SET_METER_TYPE(state, meterType) {
      state.meterType = meterType
  },
  SET_TODO_NUM(state, val) {
      state.todoNum = val
      localStorage.setItem('todoNum', val)
  },
  SET_POLLING_TIMER(state, timer) { // 添加定时器的 mutation
      state.pollingTimer = timer
  },
  CLEAR_POLLING_TIMER(state) { // 清除定时器的 mutation
      clearInterval(state.pollingTimer)
      state.pollingTimer = null
  },
  selectedNode(state, val) {
      state.selectedNode = val
  },
  loadForm(state, val) {
      state.design = val
  },
  setIsEdit(state, val) {
      state.isEdit = val
  }

  },
  // 异步方法 调用方法,this.$store.dispatch("xxx")
  actions: {
    updateMeterType({ commit }, meterType) {
      commit('SET_METER_TYPE', meterType)
  }, 
  startPolling({ commit, dispatch }) {
      dispatch('setTodoNum')
      const timer = setInterval(() => {
          dispatch('setTodoNum')
      }, 10 * 1000) // 每10秒请求一次
      commit('SET_POLLING_TIMER', timer)
  },
  stopPolling({ commit }) {
      commit('CLEAR_POLLING_TIMER')
  }
  },
  // Vuex属性计算,在视图里面当变量使用
  getters: {
  },
  // 模块化注册
  modules: {
    webSocket,
    menuTab,
    user
  }
})

export default store
